export const parseJson = obj => {
    return JSON.parse(obj);
}